import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const PinPageMain = React.lazy(() => import('./main/PinPageMain'));
const UnsubPageMain = React.lazy(() => import('./main/UnsubPageMain'));
const TermsPageMain = React.lazy(() => import('./main/TermsPageMain'));
const PrivacyPageMain = React.lazy(() => import('./main/PrivacyPageMain'));
const SuccessPageMain = React.lazy(() => import('./main/SuccessPageMain'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<PinPageMain />} />
          <Route path="/unsub" element={<UnsubPageMain />} />
          <Route path="/terms" element={<TermsPageMain />} />
          <Route path="/privacy" element={<PrivacyPageMain />} />
          <Route path="/success" element={<SuccessPageMain />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;